<template>
  <div class="field">
    <slot></slot>
    <div v-if="showFieldErrors && fieldError" class="field-error">{{ fieldErrorDetail }}</div>
    <div v-if="formErrors && formErrors[name]" class="field-error">{{ formErrors[name][0] }}</div>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default: () => {},
    },
    name: {
      type: String,
      default: '',
    },
    showFieldErrors: {
      type: Boolean,
      default: false,
    },
    formErrors: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    fieldError() {
      return this.errors.filter(e => e.field === this.name).length > 0
    },
    fieldErrorDetail() {
      return this.errors.filter(e => e.field === this.name)[0].detail
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/forms';
@import '../styles/variables';

.field {
  margin-bottom: 1.25rem;
}

.field-group {
  display: flex;
  flex-direction: column;

  &__label {
    width: 50%;
  }
}

.field-error {
  margin-top: 2px;
  color: #ff0000;
  font-size: 0.8rem;
}
</style>
